const BASE_URL = '/app/house';

/**
 * Fetch preview data for extending timed lots using the fetch API for more granular error handling
 * @param {string} houseRef - The house reference
 * @param {string} catalogRef - The catalog reference
 * @returns {Promise} Response with extension options and token
 */
export async function fetchLotExtensionPreview(houseRef, catalogRef) {
  try {
    const response = await fetch(
      `${BASE_URL}/${houseRef}/catalog/${catalogRef}/extend-timed-lots/preview`,
      {
        method: 'GET',
        credentials: 'include'
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
}

/**
 * Extend timed lots by specified minutes using fetch
 * @param {string} houseRef - The house reference
 * @param {string} catalogRef - The catalog reference
 * @param {number} extensionMinutes - Number of minutes to extend
 * @param {string} extendLotsToken - Token from preview call
 * @returns {Promise} Response with extension result
 */
export async function extendTimedLots(houseRef, catalogRef, extensionMinutes, extendLotsToken) {
  try {
    const response = await fetch(
      `${BASE_URL}/${houseRef}/catalog/${catalogRef}/extend-timed-lots`,
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          extensionMinutes,
          extendLotsToken
        })
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
}
